import { ChangeDetectionStrategy, Component, Inject, Input, TemplateRef } from '@angular/core';
import { P500UIBaseModal, IModalsService, IMODALS_SERVICE } from '@platform500services/p500-ui-kit';
import { Router } from '@angular/router';

@Component({
  selector: 'gtd-help-information-modal',
  templateUrl: './help-information.modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpInformationModal extends P500UIBaseModal {
  @Input() title = $localize`:@@common.help_information:Help Information`;
  @Input() subTitle;
  // @Input() linkToDocs = 'https://docs.platform500.com/';
  @Input() linkToDocs: string;
  @Input() content: TemplateRef<any>;

  constructor(@Inject(IMODALS_SERVICE) public modalsService: IModalsService, public router: Router) {
    super(modalsService, router);
  }
}
